import styled from "styled-components";
import { Link as LinkComponent } from "react-router-dom";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export default styled(LinkComponent)`
  text-align: center;
  line-height: 30px;
  font-family: ${(props) => (props.selected ? fonts.fontBauMedium : fonts.fontConceptRegular)};
  position: relative;
  height: 30px;
  width: 60%;
  border-radius: 25px;
  border: 1px solid black;
  margin-right: -25px;
  margin-bottom: 5px;
  &:hover,
  &:focus {
    color: ${(props) => (props.selected ? colors.white : colors.black)};
  }
  color: ${(props) => (props.selected ? colors.white : colors.black)};
  background-color: ${(props) => (props.selected ? colors.black : colors.white)};
  z-index: ${(props) => (props.selected ? 1 : 0)};

  ${breakpoints.smUp} {
    max-width: 200px;
  }
`;
